import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormGroup, FormsModule, ReactiveFormsModule, FormGroupDirective } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatSliderModule } from '@angular/material/slider';

@Component({
  selector: 'app-range-input',
  standalone: true,
  imports: [CommonModule, MatSliderModule, ReactiveFormsModule, FormsModule],
  templateUrl: './range-input.component.html',
  styleUrl: './range-input.component.scss',
  viewProviders: [{provide: ControlContainer, useExisting: FormGroupDirective}]
})
export class RangeInputComponent implements OnInit {
  @Input() formGroupName!: string

  childForm!: FormGroup

  constructor(
    private parentForm: FormGroupDirective,
  ){}

  ngOnInit(){
    this.childForm = this.parentForm.form
    console.log(this.parentForm.control)
    // initialise form
    this.childForm = this.parentForm.control.get(this.formGroupName) as FormGroup
  }
}
